import React from "react";
import { Card,CardBody, Row, Col, Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader } from "reactstrap";
import LessonCard from "./LessonCard";

import EditNodes from "./EditNodes";
import LessonData from "./LessonData";
import LessonRules from "./AuthorLesson/LessonRules";
import LessonDeckBank from "./AuthorLesson/LessonDeckBank";
import LessonItemBank from "./AuthorLesson/LessonItemBank";
import AddItems from './AuthorLesson/AddItems';
import PreviewItem from './AuthorLesson/PreviewItem';
import SimulateItem from './AuthorLesson/SimulateItem';

import AddRules from "./AuthorLesson/AddRules";

import AddDecks from "./AuthorLesson/AddDecks";
import CreateDeckLogic from "./AuthorLesson/CreateDeckLogic";

function getBreadcrums(breadc) {
  let breadcrums = "";
  breadc.forEach((breadcrum, index) => {
    `/ ${breadcrum} `;
    if (index === 0) {
      breadcrums = breadcrums + breadcrum;
    } else {
      breadcrums = breadcrums + ` / ` + breadcrum;
    }
  });
  return breadcrums;
}
export default class AuthorLessons extends React.Component {
  state = {
    openedCards: {
      editNode:false,
      addRules:false,
      addItems:false,
      simulateItem:false,
      previewItem:false,
      addDecks:false,
      createDeckLogic:false
    },
    previewDeck:false
  };
  toggleRightCards(name,status){
    let changed = {
      [name]:status
    };
    console.log(changed)
    this.setState({
      openedCards:changed
    })

  }
  handlePreview = value => {
    
    this.setState({
      previewDeck:true,
      selectedDeck:value
    });
  };
  render() {
    let breadcrums = getBreadcrums([
      "Course",
      "Subcourse",
      "Section",
      "Lesson"
    ]);
    const {openedCards} = this.state;

    
    const previewModel = show => (
      <Modal isOpen={show}>
        <ModalHeader>Deck Name</ModalHeader>
        <ModalBody>
          <div>
            <label>Name: </label>
            {this.state.selectedDeck.name}
            <span />
          </div>
          <div>
            <label>Type: </label>
            {this.state.selectedDeck.type}
            <span />
          </div>
          <div>
            <label>Tags: </label>
            {this.state.selectedDeck.tags}
            <span />
          </div>
          <div>
            <label>Nodes: </label>
            {this.state.selectedDeck.nodes}
            <span />
          </div>
          <div>
            <label>Code: </label>
            {this.state.selectedDeck.code}
            <span />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            onClick={() => this.setState({ previewDeck: false })}
            color="secondary"
          >
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    );
    return (
      <React.Fragment>
      <Card className="course-edit-container">
        <span className='breadcrums'>{breadcrums}</span>
        <Row>
          <Col md="8" sm="8">
            <h3 className="heading">
              Edit <span className="name">lesson-name</span> Lesson
            </h3>
          </Col>
          <Col md="4" sm="4">
            <Button
              style={{ float: "right", margin: "20px 0 20px 0" }}
              className="add-btn"
              size="sm"
            >
              + Create New Lesson
            </Button>
          </Col>
        </Row>
        <Col colSpan="12" className="card-body">
         <Row>
            <Col colSpan="6" sm="12" md="6" lg="6" className="lesson-cards-container">
                <Row>
                  <Col>
                    <LessonData
                      editNode={() => this.toggleRightCards("editNode",true)}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <LessonRules AddRule={() => this.toggleRightCards("addRules",true)}  />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <LessonItemBank 
                     addItems={() => this.toggleRightCards('addItems',true)}
                     simulateItem={() => this.toggleRightCards('simulateItem',true)}
                     previewItem={() => this.toggleRightCards('previewItem',true)}
                      />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <LessonDeckBank
                     addDecks={() => this.toggleRightCards('addDecks',true)}
                     createDeckLogic={() => this.toggleRightCards('createDeckLogic',true)}
                     />
                  </Col>
                </Row>
            </Col>
            <Col colSpan="6" sm="12" md="6" lg="6">
              {
                openedCards.editNode && <EditNodes
                  closeEditNode={() => this.toggleRightCards("editNode",false)}
                  onUpdateNodes={nodes =>
                    this.setState({ nodes, editNode: false })
                  }
                />
              }
              {
                openedCards.addRules && <AddRules
                closeAddRules={(cardName) => this.toggleRightCards("addRules",false)}
                onUpdateRules={nodes =>
                  this.setState({ nodes, editNode: false })
                }
                />
              }
              {
                 openedCards.addItems && <AddItems
                  onClose={() => this.toggleRightCards('addItems',false)}
                 onUpdateNodes={nodes =>
                   this.setState({ nodes, editNode: false })
                 }
               />
              }
              {
                 openedCards.simulateItem && <SimulateItem />
              }
              {
                 openedCards.previewItem && <PreviewItem />
              }
              {
                 openedCards.addDecks && <AddDecks
                 addDecks={() => this.toggleRightCards('addDecks',true)}
                 onClose={() => this.toggleRightCards('addDecks',false)}
                 showPreview={this.handlePreview}
               />
              }
              {
                 openedCards.createDeckLogic && <CreateDeckLogic
                 createDeckLogic={() => this.toggleRightCards('createDeckLogic',true)}
                 onClose={() => this.toggleRightCards('createDeckLogic',false)}
                 
               />
              }
            </Col>
          </Row>
         </Col>
      </Card>
      {this.state.previewDeck &&
          previewModel(this.state.previewDeck)}
      </React.Fragment>
      
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Users/Authors/AuthorLessons.js